import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Tab, Tabs, Typography, CircularProgress } from '@mui/material';
// import LeftSidebar from '../partials/leftSidebar';
import Row from 'react-bootstrap/Row';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { object, string } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid2";
import { getMethod, putFormMethod, putMethod } from '../../../services/apiService';
import blueEditicon from "../../../assets/images/icon/blue-editicon.svg"
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { clearStorageAndCookies } from '../../../services/authService';
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../../services/placeService";
import PhoneInput from "react-phone-input-2";

interface OrderDetailTabTwoProps {
    isEditable: boolean;
}
interface SiteDetail {
    name: string;
    siteDevice: string;
    email: string;
    addressline1: string;
    addressline2: string;
    postalcode: string;
    city: string | null;
    state: string | null;
    country: string | null;
    number: string;
    mobile: string;
}



function OrderDetailTabTwo() {
    const { setToast } = useToastContext() as ToastContext;
    const navigate = useNavigate();

    const [initialValues, setInitialValues] = useState({
        name: '',
        siteDevice: '',
        email: '',
        addressline1: '',
        addressline2: '',
        postalcode: '',
        city: '',
        state: '',
        country: '',
        number: '',
        mobile: '',
    });

    const location = useLocation();
    const { order, siteId } = location.state || {};


    const [activeTab, setActiveTab] = useState(0);
    const [isEditable, setIsEditable] = useState(false);
    const [siteDetail, setSiteDetail] = useState<any>();
    const [countryList, setCountryList] = useState([]);
    const [country, setCountry] = useState("");
    const [stateList, setStateList] = useState([]);
    const [filteredStateList, setFilteredStateList] = useState([]);
    const [state, setState] = useState("");
    const [cityList, setCityList] = useState([]);
    const [filteredCityList, setFilteredCityList] = useState([]);
    const [city, setCity] = useState("");


    useEffect(() => {
        getCountryList();
        getStateList();
        getCityList();
        //fetchPartnerId();
    }, []);


    const getCountryList = async () => {
        const resp = await getCountriesAPI();
        setCountryList(resp.countries);
    }


    const getStateList = async () => {
        const resp = await getStatesAPI();
        setStateList(resp.states);
    }


    const getCityList = async () => {
        const resp = await getCitiesAPI();
        console.log(resp)
        setCityList(resp.cities);
    }


    const handleCountryChange = async (e: any, setFieldValue: any) => {
        const selectedCountryId = e.target.value;
        const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
        setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
        setFieldValue("country", selectedCountry.id.toString());

        setTimeout(() => {
            const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
            setFilteredStateList(filteredStates);
        }, 200);
    }


    const handleStateChange = async (e: any, setFieldValue: any) => {
        const selectedStateId = e.target.value;
        const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
        setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
        setFieldValue("state", selectedState.id.toString());

        setTimeout(() => {
            const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
            setFilteredCityList(filteredCities);
        }, 200);
    }


    const handleCityChange = async (e: any, setFieldValue: any) => {
        const selectedCityId = e.target.value;
        const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
        setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
        setFieldValue("city", selectedCity.id.toString());
    }

    const handleToggleEdit = () => {
        setIsEditable((prevState) => !prevState);
    };


    useEffect(() => {
        fetchSiteDetail();
    }, []);


    const fetchSiteDetail = async () => {
        let resp;
        if (siteId)
            resp = await getMethod("customer/site/" + siteId);
        else
            resp = await getMethod("customer/site/" + order?.vSiteOrder?.siteId);
        if (resp?.status === 200) {
            console.log(resp)
            setSiteDetail(resp?.data?.result[0])
        } else {
            setToast(resp?.data?.message, "error");
        }
    }


    useEffect(() => {
        if (siteDetail) prepareInititalValues();
    }, [siteDetail])


    const getCountryId = async (country_name: string) => {
        const country: any = countryList.find((country: any) => country.name === country_name);
        console.log(country)
        if (country !== undefined) {
            setCountry(country.name);
            return country.id;
        }
        else return "";
    }

    const getStateId = async (state_name: string, country_id: string) => {
        const f_statelist = stateList?.filter((item: any) => item.country_id === country_id);
        setFilteredStateList(f_statelist);
        const state: any = f_statelist.find((state: any) => state.name === state_name && state.country_id === country_id);
        console.log(state)
        if (state !== undefined) {
            setState(state.name);
            return state.id;
        }
        else return "";
    }

    const getCityId = async (city_name: string, state_id: string) => {
        console.log(city_name, state_id);

        const f_citylist = cityList?.filter((item: any) => item.state_id === state_id);
        setFilteredCityList(f_citylist);
        const city: any = f_citylist.find((city: any) => city.name === city_name && city.state_id === state_id);
        console.log(city)
        if (city !== undefined) {
            setCity(city.name);
            return city.id;
        }
        else return "";
    }


    const prepareInititalValues = async () => {
        let country_id = "";
        if (siteDetail?.address?.country !== "") {
            country_id = await getCountryId(siteDetail?.address?.country);
        }

        let state_id = "";
        if (siteDetail?.address?.state !== "" && country_id != "") {
            state_id = await getStateId(siteDetail?.address?.state, country_id.toString());
        }

        let city_id = "";
        if (siteDetail?.address?.city !== "" && state_id != "") {
            city_id = await getCityId(siteDetail?.address?.city, state_id.toString());
        }
        setInitialValues({
            name: siteDetail?.name || '',
            siteDevice: siteDetail?.deviceid || '',
            email: siteDetail?.contact?.email[0]?.id || '',
            addressline1: siteDetail?.address?.addressline1 || '',
            addressline2: siteDetail?.address?.addressline2 || '',
            postalcode: siteDetail?.address?.postalcode || '',
            country: country_id || '',
            state: state_id || '',
            city: city_id || '',
            mobile: siteDetail?.contact?.mobile[0]?.number || '',
            number: siteDetail?.contact?.phone?.number || '',
        });
    }


    return (
        <Formik initialValues={initialValues}
            enableReinitialize={true} // Enable reinitialization
            validationSchema={object({
                name: string().trim().required("Site / Device name is required!"),
                email: string().email().required("Email ID is required!"),
                address_line_1: string().trim().optional(),
                address_line_2: string().trim().optional(),
                postal_code: string().trim().optional(),
                city: string().trim().optional(),
                state: string().trim().optional(),
                country: string().trim().optional(),
                number: string().trim().optional(),
                mobile: string().trim().optional(),
            })}

            onSubmit={async (values, { setSubmitting }) => {
                console.log('Form values', values);

                const normalizedMobile =
                    values?.mobile
                        ? values.mobile.startsWith("+")
                            ? values.mobile
                            : `+${values.mobile}`
                        : values?.mobile;

                setIsEditable((prevState) => !prevState);
                let payload = {
                    "name": values.name,
                    "email": values.email,
                    "addressline1": values.addressline1,
                    "addressline2": values.addressline2,
                    "postalcode": values.postalcode,
                    "city": city,
                    "country": country,
                    "state": state,
                    "number": values.number,
                    "mobile": normalizedMobile
                }                

                let resp;
                if (siteId)
                    resp = await putFormMethod("customer/site/" + siteId, payload);
                else
                    resp = await putFormMethod("customer/site/" + order?.vSiteOrder?.siteId, payload);
                if (resp?.status === 200) {
                    setToast(resp?.data?.message, "success");
                } else {
                    setToast(resp?.data?.message, "error");
                }
            }}
        >

            {({ values, errors, isSubmitting, isValid, resetForm, setFieldValue, setFieldTouched, touched }) => (
                <React.Fragment>
                    <ToastContainer />


                    <Form autoComplete="off">
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0, mb: 2 }}>

                            {isEditable && <Button type="submit" sx={{ backgroundColor: 'transparent', border: '1px solid #0B4A62', paddingInline: '16px', paddingBlock: '8px', borderRadius: '30px', cursor: 'pointer', color: '#0699CE', fontSize: '14px', fontWeight: 500, mr: 2, textTransform: "none" }} >
                                Save Changes
                            </Button>}
                            {activeTab != 2 && <Box
                                onClick={() => {
                                    if (isEditable) {
                                        resetForm();
                                    }
                                    handleToggleEdit();
                                }}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: `${isEditable ? '0px solid #0B4A62' : '1px solid #0B4A62'}`,
                                    paddingInline: '16px',
                                    paddingBlock: '12px',
                                    borderRadius: '30px',
                                    cursor: 'pointer',
                                    color: '#0699CE',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                }}
                            >
                                {isEditable ? 'Cancel' : (
                                    <>
                                        <img src={blueEditicon} alt="edit" />
                                        &nbsp;&nbsp; Edit
                                    </>
                                )}
                            </Box>}


                        </Box>
                        <Row className="mb-3">
                            {/* Row 1 - Customer Name and Site/Device */}
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Site Name</RBFORM.Label>
                                        <Field
                                            name="name"
                                            type="text"
                                            placeholder="Enter site name"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Unique ID</RBFORM.Label>
                                        <Field
                                            name="siteDevice"
                                            type="text"
                                            placeholder="Enter unique ID"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>

                            {/* Row 2 - Email, First Name, Last Name */}
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Email</RBFORM.Label>
                                        <Field
                                            name="email"
                                            type="email"
                                            placeholder="Enter email"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>

                            {/* Row 4 - Address Line 1 and Address Line 2 */}
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Address Line 1</RBFORM.Label>
                                        <Field
                                            name="addressline1"
                                            type="text"
                                            placeholder="Enter address Line 1"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Address Line 2</RBFORM.Label>
                                        <Field
                                            name="addressline2"
                                            type="text"
                                            placeholder="Enter address Line 2"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>



                            {/* Row 5 - Postal Code, City, State, Country */}
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Country</RBFORM.Label>
                                        <Field
                                            name="country"
                                            as="select"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                                            disabled={!isEditable}
                                        >
                                            <option>Select Country</option>
                                            {countryList?.length > 0 && (
                                                countryList.map((country: any) => (
                                                    <option key={country.id} value={country.id}>
                                                        {country.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">State</RBFORM.Label>
                                        <Field
                                            name="state"
                                            as="select"
                                            placeholder="State"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleStateChange(e, setFieldValue)}
                                            disabled={!isEditable}
                                        >
                                            <option>Select State</option>
                                            {filteredStateList?.length > 0 && (
                                                filteredStateList.map((state: any) => (
                                                    <option key={state.id} value={state.id}>
                                                        {state.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">City</RBFORM.Label>
                                        <Field
                                            name="city"
                                            as="select"
                                            placeholder="City"
                                            className="inputC custDropdown"
                                            onChange={(e: any) => handleCityChange(e, setFieldValue)}
                                            disabled={!isEditable}
                                        >
                                            <option>Select City</option>
                                            {filteredCityList?.length > 0 && (
                                                filteredCityList.map((city: any) => (
                                                    <option key={city.id} value={city.id}>
                                                        {city.name}
                                                    </option>
                                                ))
                                            )}
                                        </Field>
                                    </RBFORM.Group>
                                </Grid>

                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Postal Code</RBFORM.Label>
                                        <Field
                                            name="postalcode"
                                            type="text"
                                            placeholder="Enter postalcode"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>

                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                                        <Field
                                            name="number"
                                            type="text"
                                            placeholder="Phone"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                                <Grid size={{ xs: 12, md: 3 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Mobile Number</RBFORM.Label>
                                        <PhoneInput
                                            specialLabel=""
                                            dropdownClass="user-phone-input-dropdown"
                                            containerClass="user-phone-input-container"
                                            inputClass={`modalForm-input user-phone-input ${errors.mobile && touched.mobile ? "errors" : ""}`}
                                            inputStyle={{
                                                boxShadow: 'none',
                                                color: "#A5A8A9",
                                                border: errors.mobile && touched.mobile ? "1px solid red" : "1px solid #313838",
                                                width: "100%",
                                                height: "40px",
                                                backgroundColor: "#192529",
                                            }}
                                            value={values.mobile}
                                            onChange={(number) => setFieldValue("mobile", number)}
                                            onBlur={() => setFieldTouched("mobile", true)}
                                            disabled={!isEditable}
                                        />
                                        {errors.mobile && touched.mobile && (
                                            <div className="error-message" style={{ color: "#f44336" }}>{errors.mobile}</div>
                                        )}
                                    </RBFORM.Group>
                                </Grid>
                            </Grid>
                        </Row>

                    </Form>

                </React.Fragment>
            )}
        </Formik>
    )
}

export default OrderDetailTabTwo